/*global google*/
/*global window*/
import React from "react";
import { useHistory } from "react-router-dom";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  GroundOverlay,
  Marker,
} from "react-google-maps";
import NumberFormat from "react-number-format";
import { Button, Grid } from "tabler-react";
import * as qs from "qs";
import { ScrollElement, scroller } from "react-scroll";
import Modal from "react-modal";
import { PMT } from "@formulajs/formulajs";
import { useAlert } from "react-alert";
import { isMobile } from "react-device-detect";

Modal.setAppElement("#root");

const Map = withScriptjs(
  withGoogleMap((props) => (
    <GoogleMap
      ref={props.mapRef}
      mapTypeId={google.maps.MapTypeId.SATELLITE}
      options={{
        fullscreenControl: false,
        mapTypeControl: false,
        scrollwheel: true,
        signInControl: false,
        streetViewControl: false,
      }}
      defaultZoom={18}
      defaultCenter={{
        lat: parseFloat(props.data?.protocol.project.nativeMapLatitude || 0),
        lng: parseFloat(props.data?.protocol.project.nativeMapLongitute || 0),
      }}
    >
      {props.data && (
        <GroundOverlay
          defaultUrl={props.data?.protocol.project.nativeMapOverlayImageUrl}
          defaultBounds={
            new google.maps.LatLngBounds(
              new google.maps.LatLng(
                parseFloat(
                  props.data?.protocol.project
                    .nativeMapOverlayImageLeftLatitude,
                ),
                parseFloat(
                  props.data?.protocol.project
                    .nativeMapOverlayImageLeftLongitude,
                ),
              ),
              new google.maps.LatLng(
                parseFloat(
                  props.data?.protocol.project
                    .nativeMapOverlayImageRightLatitude,
                ),
                parseFloat(
                  props.data?.protocol.project
                    .nativeMapOverlayImageRightLongitude,
                ),
              ),
            )
          }
        />
      )}
      {props.data &&
        props.data?.lots?.map((lot) => (
          <Marker
            key={lot.id}
            position={{
              lat: lot.data?.coordinate.latitude,
              lng: lot.data?.coordinate.longitude,
            }}
            motionTracking={false}
            icon={
              lot.id === props.selectedLot.id
                ? null
                : lot.status === "À VENDA" &&
                    lot.preReservationCode &&
                    lot.preReservationEnabled &&
                    lot.isOwner
                  ? "https://www.guerini.com.br/mapadevendas/images/ICON_BLUE.png"
                  : lot.status === "À VENDA" &&
                      lot.preReservationCode &&
                      lot.preReservationEnabled
                    ? "https://www.guerini.com.br/mapadevendas/images/RESERVADO.png"
                    : lot.status === "RESERVADO" &&
                        lot.isOwner &&
                        lot.preReservationStatus === "waiting_for_audit"
                      ? "https://www.guerini.com.br/mapadevendas/images/ICON_CHECKLIST.png"
                      : lot.status === "RESERVADO" &&
                          lot.isOwner &&
                          lot.preReservationStatus === "approved"
                        ? "https://www.guerini.com.br/mapadevendas/images/ICON_CONFIRM_W.png"
                        : lot.status === "RESERVADO" &&
                            lot.isOwner &&
                            lot.preReservationStatus === "reproved"
                          ? "https://www.guerini.com.br/mapadevendas/images/ICON_X.png"
                          : lot.status === "À VENDA"
                            ? "https://www.guerini.com.br/mapadevendas/images/AVENDA.png"
                            : lot.status === "VENDIDO"
                              ? "https://www.guerini.com.br/mapadevendas/images/VENDIDO.png"
                              : lot.status === "RESERVADO"
                                ? "https://www.guerini.com.br/mapadevendas/images/RESERVADO.png"
                                : "https://www.guerini.com.br/mapadevendas/images/SEMSTATUS.png"
            }
            onClick={() => props.onLotClick(lot)}
          />
        ))}
      {props.data &&
        props.data?.linkedLots?.map((lot) => (
          <Marker
            key={lot.id}
            position={{
              lat: lot.data?.coordinate.latitude,
              lng: lot.data?.coordinate.longitude,
            }}
            motionTracking={false}
            icon={
              lot.id === props.selectedLot.id
                ? null
                : lot.status === "À VENDA" &&
                    lot.preReservationCode &&
                    lot.preReservationEnabled &&
                    lot.isOwner
                  ? "https://www.guerini.com.br/mapadevendas/images/ICON_BLUE.png"
                  : lot.status === "À VENDA" &&
                      lot.preReservationCode &&
                      lot.preReservationEnabled
                    ? "https://www.guerini.com.br/mapadevendas/images/RESERVADO.png"
                    : lot.status === "RESERVADO" &&
                        lot.isOwner &&
                        lot.preReservationStatus === "waiting_for_audit"
                      ? "https://www.guerini.com.br/mapadevendas/images/ICON_CHECKLIST.png"
                      : lot.status === "RESERVADO" &&
                          lot.isOwner &&
                          lot.preReservationStatus === "approved"
                        ? "https://www.guerini.com.br/mapadevendas/images/ICON_CONFIRM_W.png"
                        : lot.status === "RESERVADO" &&
                            lot.isOwner &&
                            lot.preReservationStatus === "reproved"
                          ? "https://www.guerini.com.br/mapadevendas/images/ICON_X.png"
                          : lot.status === "À VENDA"
                            ? "https://www.guerini.com.br/mapadevendas/images/AVENDA_PASTEL.png"
                            : lot.status === "VENDIDO"
                              ? "https://www.guerini.com.br/mapadevendas/images/VENDIDO_PASTEL.png"
                              : lot.status === "RESERVADO"
                                ? "https://www.guerini.com.br/mapadevendas/images/RESERVADO_PASTEL.png"
                                : "https://www.guerini.com.br/mapadevendas/images/SEMSTATUS_PASTEL.png"
            }
            onClick={() => props.onLotClick(lot)}
          />
        ))}
    </GoogleMap>
  )),
);

const LotCard = ScrollElement(
  ({
    name,
    id,
    item,
    project,
    selectedLot,
    setSelectedLot,
    isLinkedLot,
    onSimulationClick,
    onPreReservationClick,
  }) => (
    <div
      name={name}
      id={id}
      className="card mb-2"
      style={
        selectedLot.id === item.id
          ? {
              boxShadow: "0px 12px 4px -4px rgba(32,32,32,0.5)",
              zIndex: 2,
              borderWidth: 1,
              borderStyle: isLinkedLot ? "dashed" : "solid ",
              borderColor: "rgba(32,32,32,0.5)",
            }
          : {
              cursor: "pointer",
            }
      }
      onClick={() => {
        if (selectedLot.id !== item.id) {
          setSelectedLot(item);
        }
      }}
    >
      <div
        className="d-flex justify-content-between m-3"
        style={{ borderBottom: "1px solid #DDD" }}
      >
        <div>
          <div
            className="primary-color"
            style={{ fontSize: "18px", fontWeight: 800 }}
          >
            {item.identifier}
          </div>
          <small className="d-block text-muted">
            {item.kind
              ? item.kind
              : project?.kind === "residential"
                ? "Residencial"
                : project?.kind === "business"
                  ? "Empresarial"
                  : project?.kind === "area"
                    ? "Área"
                    : project?.kind === "mixed"
                      ? "Misto"
                      : ""}{" "}
            {project?.name ? ` - ${project?.name}` : ""}
          </small>
        </div>
        <div className="text-muted text-right d-flex flex-column">
          <span
            style={
              item.preReservationEnabled && item.preReservationCode
                ? {
                    textDecorationLine: "line-through",
                    textDecorationStyle: "solid",
                  }
                : {}
            }
            className={`${item.status === "À VENDA" ? "green-color" : item.status === "VENDIDO" ? "red-color" : item.status === "RESERVADO" ? "yellow-color" : ""}`}
          >
            {item.status}
          </span>
          {item.preReservationEnabled && item.preReservationCode && (
            <small className="d-block muted">PRÉ-RESERVADO</small>
          )}
        </div>
      </div>
      <div className="px-3 pb-3" style={{ fontSize: "14px" }}>
        <div className="d-flex justify-content-between py-1">
          <span>Área Real (m²)</span>
          <NumberFormat
            value={item.area / 100}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            displayType="text"
            fixedDecimalScale={true}
            renderText={(value) => (
              <span style={{ textAlign: "right" }}>{value}</span>
            )}
          />
        </div>

        {item.originalAreaPrice &&
          parseInt(item.originalAreaPrice) !== parseInt(item.areaPrice) && (
            <div className="d-flex justify-content-between py-1">
              <span>Preço Original do Lote (R$/m²)</span>
              <NumberFormat
                value={item.originalAreaPrice / 100}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                displayType="text"
                fixedDecimalScale={true}
                renderText={(value) => (
                  <span
                    style={{
                      textAlign: "right",
                      textDecorationLine: "line-through",
                    }}
                  >
                    {value}
                  </span>
                )}
              />
            </div>
          )}

        <div className="d-flex justify-content-between py-1">
          <span>Preço Final do Lote (R$/m²)</span>
          <NumberFormat
            value={item.areaPrice / 100}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            displayType="text"
            fixedDecimalScale={true}
            renderText={(value) => (
              <span style={{ textAlign: "right" }}>{value}</span>
            )}
          />
        </div>

        {item.originalFinalPrice &&
          parseInt(item.originalFinalPrice) !== parseInt(item.finalPrice) && (
            <div className="d-flex justify-content-between py-1">
              <span>Valor Original do Lote</span>
              <NumberFormat
                value={item.originalFinalPrice / 100}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                displayType="text"
                fixedDecimalScale={true}
                renderText={(value) => (
                  <span
                    style={{
                      textAlign: "right",
                      textDecorationLine: "line-through",
                    }}
                  >
                    {value}
                  </span>
                )}
              />
            </div>
          )}

        <div className="d-flex justify-content-between py-1">
          <span>Valor Final do Lote</span>
          <NumberFormat
            value={item.finalPrice / 100}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            displayType="text"
            fixedDecimalScale={true}
            prefix="R$ "
            renderText={(value) => (
              <span style={{ textAlign: "right", fontWeight: 700 }}>
                {value}
              </span>
            )}
          />
        </div>

        {item.data?.measurementLink != null &&
          item.data?.measurementLink.length > 0 && (
            <div className="d-flex justify-content-between py-1">
              <span>Medidas, Foto e Observações</span>
              <span style={{ textAlign: "right" }}>
                <a target="_blank" href={item.data?.measurementLink}>
                  Link
                </a>
              </span>
            </div>
          )}
        {item.status !== "À VENDA" && item.reservationCode && (
          <div className="d-flex justify-content-between py-1">
            <span>Protocolo</span>
            <span style={{ textAlign: "right" }}>
              <a target="_blank" href={item.link}>
                {item.reservationCode}
              </a>
            </span>
          </div>
        )}
        {item.status === "À VENDA" &&
          item.preReservationCode &&
          item.preReservationEnabled && (
            <div className="d-flex justify-content-between py-1">
              <span>Protocolo Pré-reserva</span>
              <span style={{ textAlign: "right" }}>
                <a target="_blank" href={item.link}>
                  {item.preReservationCode}
                </a>
              </span>
            </div>
          )}
      </div>
      {selectedLot.id === item.id &&
        item.simulationEnabled &&
        !item.preReservationEnabled &&
        !isLinkedLot && (
          <div
            className="d-flex justify-content-between mx-3 mb-1"
            style={{ borderTop: "1px solid #DDD" }}
          >
            <div></div>
            <div className="text-center py-2" style={{ fontWeight: 600 }}>
              Faça simulação no aplicativo
            </div>
          </div>
        )}
      {selectedLot.id === item.id &&
        item.status === "À VENDA" &&
        item.preReservationEnabled &&
        !item.preReservationCode &&
        onPreReservationClick &&
        !isLinkedLot && (
          <div
            className="d-flex justify-content-between mx-3 mb-1"
            style={{ borderTop: "1px solid #DDD" }}
          >
            <div></div>
            <div className="text-right">
              <Button
                link
                className="px-0"
                onClick={() => onPreReservationClick(item)}
              >
                Fazer Pré-reserva
              </Button>
            </div>
          </div>
        )}
      {item.status === "À VENDA" &&
        item.preReservationEnabled &&
        item.preReservationCode &&
        item.isOwner &&
        item.preReservationStatus === "waiting_for_confirmation" &&
        !isLinkedLot && (
          <div
            className="d-flex justify-content-between mx-3 mb-1"
            style={{ borderTop: "1px solid #DDD" }}
          >
            <div className="text-center py-2" style={{ fontWeight: 600 }}>
              Peça para o corretor concluir a sua reserva
            </div>
          </div>
        )}
      {selectedLot.id === item.id &&
        item.status === "RESERVADO" &&
        item.isOwner &&
        item.preReservationStatus === "waiting_for_audit" &&
        !isLinkedLot && (
          <div
            className="d-flex mx-3 mb-1"
            style={{ borderTop: "1px solid #DDD" }}
          >
            <div className="text-center py-2" style={{ fontWeight: 600 }}>
              A Guerini fará a validação do pagamento
            </div>
          </div>
        )}
      {selectedLot.id === item.id &&
        item.status === "RESERVADO" &&
        item.isOwner &&
        item.preReservationStatus === "approved" &&
        !isLinkedLot && (
          <div
            className="d-flex mx-3 mb-1"
            style={{ borderTop: "1px solid #DDD" }}
          >
            <div className="text-center py-2" style={{ fontWeight: 600 }}>
              Parabéns você conseguiu este lote
            </div>
          </div>
        )}
      {selectedLot.id === item.id &&
        item.status === "RESERVADO" &&
        item.isOwner &&
        item.preReservationStatus === "reproved" &&
        !isLinkedLot && (
          <div
            className="d-flex mx-3 mb-1"
            style={{ borderTop: "1px solid #DDD" }}
          >
            <div className="text-center py-2" style={{ fontWeight: 600 }}>
              Está unidade será baixada
            </div>
          </div>
        )}
      {selectedLot.id === item.id && isLinkedLot && (
        <div
          className="d-flex mx-3 mb-1"
          style={{ borderTop: "1px solid #DDD" }}
        >
          <div className="text-center py-2" style={{ fontWeight: 600 }}>
            Este lote pertence a outro projeto, procure o corretor para saber
            mais sobre.
          </div>
        </div>
      )}
    </div>
  ),
);

function ProtocolMapPage() {
  const history = useHistory();
  const alert = useAlert();

  const [modalIsOpen, setModalIsOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [hash, setHash] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [selectedLot, setSelectedLot] = React.useState({});
  const [simulationOptions, setSimulationOptions] = React.useState([]);
  const [proposal, setProposal] = React.useState({});
  const [mode, setMode] = React.useState("desktop");

  const mapRef = React.useRef(null);

  React.useEffect(() => {
    if (history.location.search && history.location.search.length > 0) {
      const params = qs.parse(history.location.search.replace("?", ""));
      if (params.h && params.h.length > 0) {
        setHash(params.h);
      }

      if (params.mode && params.mode.length > 0) {
        setMode(params.mode);
      } else if (isMobile) {
        setMode("mobile");
      }
    }
  }, []);

  React.useEffect(() => {
    (async () => {
      if (hash && hash.length > 0) {
        const res = await fetch(`/api/broker/maps?h=${hash}`);
        const json = await res.json();
        json.linkedProjects = json?.linkedProjects?.reduce(
          (acc, project) => ({ ...acc, [project.id]: project }),
          {},
        );
        setData(json);
      }
    })();
  }, [hash]);

  React.useEffect(() => {
    if (selectedLot.id && data && mapRef.current) {
      scroller.scrollTo(`${selectedLot.id}`, {
        containerId: "lots",
        smooth: true,
      });

      mapRef.current.panTo(
        new google.maps.LatLng(
          selectedLot.data?.coordinate.latitude,
          selectedLot.data?.coordinate.longitude,
        ),
      );
    }
  }, [selectedLot]);

  return data ? (
    <div style={{ height: "100%", width: "100%" }}>
      <div
        style={{
          bottom: 0,
          right: 0,
          position: "absolute",
          top: 0,
          left: mode === "desktop" ? 384 : 0,
        }}
      >
        <Map
          mapRef={mapRef}
          data={data}
          selectedLot={selectedLot}
          onLotClick={setSelectedLot}
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyB4kgwYSTYdTsT6efHQLYOPZUuB-S5zTNI&v=3.42&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `100%` }} />}
          mapElement={<div style={{ height: `100%` }} />}
        />
      </div>
      {mode === "desktop" ? (
        <div
          style={{
            backgroundColor: "#EEF0F2",
            bottom: 0,
            left: 0,
            position: "absolute",
            top: 0,
            width: 384,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              left: 0,
              overflowY: "scroll",
              position: "absolute",
              right: 0,
              top: 0,
              boxShadow: "0px 8px 4px -4px rgba(32,32,32,0.2)",
              borderBottom: "1px solid rgba(32,32,32,0.2)",
              zIndex: 10,
              overflowY: "none",
            }}
          >
            <div
              className="d-flex justify-content-between p-3 pb-1"
              style={{ borderBottom: "1px solid #DDD" }}
            >
              <div>
                <div
                  className="primary-color"
                  style={{ fontSize: "18px", fontWeight: 800 }}
                >
                  Protocolo
                </div>
                <small className="d-block">{data?.protocol.code}</small>
              </div>
              <div>
                <Button
                  link
                  className="px-0"
                  onClick={async () => {
                    window.location.reload();
                  }}
                >
                  Recarregar
                </Button>
              </div>
            </div>
            <div className="p-3 pt-1" style={{ fontSize: "14px" }}>
              <div className="d-flex justify-content-between py-1">
                <span>Corretor(a)</span>
                <span>{data?.protocol.broker.name}</span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Cliente</span>
                <span>{data?.protocol.clientName}</span>
              </div>
            </div>
            {data?.protocol?.project?.showSimulationPriceWarning && (
              <div
                className="px-3"
                style={{
                  backgroundColor: "#FB6340",
                  color: "#FCF0F0",
                  fontSize: 12,
                  textAlign: "center",
                  height: 36,
                }}
              >
                Os valores apresentados são FICTÍCIOS com o propósito de
                simulação, apenas.
              </div>
            )}
          </div>
          <div
            id="lots"
            style={{
              backgroundColor: "#EEF0F2",
              bottom: 0,
              left: 0,
              overflowY: "scroll",
              paddingTop: 8,
              position: "absolute",
              right: 0,
              top:
                140 +
                (data?.protocol?.project?.showSimulationPriceWarning ? 36 : 0),
            }}
          >
            {data?.lots?.map((lot) => (
              <LotCard
                key={`${data?.protocol?.project?.id}_${lot.id}`}
                name={`${lot.id}`}
                item={lot}
                project={data?.protocol?.project || {}}
                isLinkedLot={false}
                selectedLot={selectedLot}
                setSelectedLot={setSelectedLot}
                onPreReservationClick={(item) => {
                  setModalIsOpen(true);
                }}
                onSimulationClick={(item) => {
                  setProposal({});

                  setSimulationOptions([
                    {
                      text: `À vista${selectedLot.appdata?.inCashDiscount ? ` - Desconto de ${(selectedLot.appdata?.inCashDiscount * 100).toFixed(2).replace(".", ",")}%` : ""}`,
                      onPress: () => {
                        const simulation = {
                          projectId: data?.protocol.project.id,
                          identifier: selectedLot.identifier,
                          area: selectedLot.area,
                          areaPrice: selectedLot.areaPrice,
                          finalPrice: parseInt(selectedLot.finalPrice),
                          kind: selectedLot.kind,
                          fundingEntry: 0,
                          fundingEntryPercent: 0,
                          outstandingBalance: 0,
                          numberOfInstallments: 1,
                          rate: 0,
                          indexingRate: 0,
                          fundingInstallmentValue:
                            selectedLot.finalPrice -
                            (selectedLot.appdata?.inCashDiscount
                              ? selectedLot.appdata?.inCashDiscount *
                                selectedLot.finalPrice
                              : 0),
                          fundingIntermediariesData: [],
                        };
                        setProposal({
                          project: data?.protocol.project,
                          lot,
                          simulation,
                        });
                      },
                    },
                    ...selectedLot.appdata?.availableInstallments.map((i) => {
                      const fundingEntry =
                        selectedLot.finalPrice *
                        selectedLot.appdata?.installments[i]
                          .minimuEntryPercentage;
                      const outstandingBalance =
                        selectedLot.finalPrice -
                        selectedLot.finalPrice *
                          selectedLot.appdata?.installments[i]
                            .minimuEntryPercentage;
                      const fundingInstallmentValue = parseInt(
                        -PMT(
                          selectedLot.appdata?.installments[i].rate,
                          i,
                          outstandingBalance,
                        ),
                      );

                      const simulation = {
                        projectId: data?.protocol.project.id,
                        identifier: selectedLot.identifier,
                        area: selectedLot.area,
                        areaPrice: selectedLot.areaPrice,
                        finalPrice: parseInt(selectedLot.finalPrice),
                        kind: selectedLot.kind,
                        fundingEntry: parseInt(fundingEntry.toFixed(0)),
                        fundingEntryPercent:
                          selectedLot.appdata?.installments[i]
                            .minimuEntryPercentage * 100,
                        outstandingBalance: parseInt(
                          outstandingBalance.toFixed(0),
                        ),
                        numberOfInstallments: i,
                        rate: selectedLot.appdata?.installments[i].rate,
                        indexingRate:
                          selectedLot.appdata?.installments[i].indexingRate,
                        fundingInstallmentValue: parseInt(
                          fundingInstallmentValue.toFixed(0),
                        ),
                        fundingIntermediariesData: [],
                      };

                      return {
                        text: `${selectedLot.appdata?.installments[i].minimuEntryPercentage * 100}% + ${i}x R$ ${(fundingInstallmentValue / 100).toFixed(2).replace(".", ",")}${selectedLot.appdata?.installments[i].indexingRate ? ` + Idx` : ""}`,
                        onPress: () => {
                          setProposal({
                            project: data?.protocol.project,
                            selectedLot,
                            simulation,
                          });
                        },
                      };
                    }),
                    {
                      text: "Outro valor",
                      onPress: () => {
                        setProposal({
                          project: data?.protocol.project,
                          selectedLot,
                        });
                      },
                    },
                    {
                      text: "Fechar",
                      onPress: () => {
                        setModalIsOpen(false);
                      },
                    },
                  ]);

                  setModalIsOpen(true);
                }}
              />
            ))}
            {data?.linkedLots?.map((lot) => (
              <LotCard
                key={`${lot.projectId}_${lot.id}`}
                name={`${lot.id}`}
                item={lot}
                isLinkedLot={true}
                project={data?.linkedProjects[lot.projectId] || {}}
                selectedLot={selectedLot}
                setSelectedLot={setSelectedLot}
                onPreReservationClick={null}
                onSimulationClick={null}
              />
            ))}
          </div>
        </div>
      ) : (
        <>
          <div
            style={{
              left: 0,
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 10,
            }}
          >
            <div
              className="d-flex justify-content-between px-3 py-2"
              style={{
                borderBottom: "1px solid #DDD",
                backgroundColor: "#FFF",
              }}
            >
              <div>
                <div
                  className="primary-color"
                  style={{ fontSize: "18px", fontWeight: 800 }}
                >
                  Protocolo
                </div>
                <small className="d-block">{data?.protocol.code}</small>
              </div>
              <div>
                <Button
                  link
                  className="px-0"
                  onClick={async () => {
                    window.location.reload();
                  }}
                >
                  Recarregar
                </Button>
              </div>
            </div>
            <div
              className="px-3 py-1 pb-2"
              style={{
                fontSize: "14px",
                backgroundColor: "#FFF",
                borderBottom: "1px solid #DDD",
              }}
            >
              <div className="d-flex justify-content-between py-1">
                <span>Corretor(a)</span>
                <span>{data?.protocol?.broker.name}</span>
              </div>
              <div className="d-flex justify-content-between py-1">
                <span>Cliente</span>
                <span>{data?.protocol.clientName}</span>
              </div>
            </div>
            {data?.protocol?.project?.showSimulationPriceWarning && (
              <div
                className="px-3"
                style={{
                  backgroundColor: "#FB6340",
                  color: "#FCF0F0",
                  fontSize: 12,
                  textAlign: "center",
                  height: 36,
                }}
              >
                Os valores apresentados são FICTÍCIOS com o propósito de
                simulação, apenas.
              </div>
            )}
          </div>
          <div
            style={{
              left: 0,
              position: "absolute",
              bottom: -8,
              right: 0,
              zIndex: 10,
            }}
          >
            {selectedLot?.id && (
              <LotCard
                mode={mode}
                item={selectedLot}
                project={
                  data?.linkedProjects[selectedLot?.projectId] ||
                  data?.protocol?.project ||
                  {}
                }
                isLinkedLot={
                  data?.linkedProjects?.[selectedLot?.projectId] !== undefined
                }
                selectedLot={selectedLot}
                setSelectedLot={setSelectedLot}
                onPreReservationClick={(item) => {
                  setModalIsOpen(true);
                }}
                onSimulationClick={(item) => {
                  setProposal({});

                  setSimulationOptions([
                    {
                      text: `À vista${selectedLot.appdata?.inCashDiscount ? ` - Desconto de ${(selectedLot.appdata?.inCashDiscount * 100).toFixed(2).replace(".", ",")}%` : ""}`,
                      onPress: () => {
                        const simulation = {
                          projectId: data?.protocol.project.id,
                          identifier: selectedLot.identifier,
                          area: selectedLot.area,
                          areaPrice: selectedLot.areaPrice,
                          finalPrice: parseInt(selectedLot.finalPrice),
                          kind: selectedLot.kind,
                          fundingEntry: 0,
                          fundingEntryPercent: 0,
                          outstandingBalance: 0,
                          numberOfInstallments: 1,
                          rate: 0,
                          indexingRate: 0,
                          fundingInstallmentValue:
                            selectedLot.finalPrice -
                            (selectedLot.appdata?.inCashDiscount
                              ? selectedLot.appdata?.inCashDiscount *
                                selectedLot.finalPrice
                              : 0),
                          fundingIntermediariesData: [],
                        };
                        setProposal({
                          project: data?.protocol.project,
                          selectedLot,
                          simulation,
                        });
                      },
                    },
                    ...selectedLot.appdata?.availableInstallments.map((i) => {
                      const fundingEntry =
                        selectedLot.finalPrice *
                        selectedLot.appdata?.installments[i]
                          .minimuEntryPercentage;
                      const outstandingBalance =
                        selectedLot.finalPrice -
                        selectedLot.finalPrice *
                          selectedLot.appdata?.installments[i]
                            .minimuEntryPercentage;
                      const fundingInstallmentValue = parseInt(
                        -PMT(
                          selectedLot.appdata?.installments[i].rate,
                          i,
                          outstandingBalance,
                        ),
                      );

                      const simulation = {
                        projectId: data?.protocol.project.id,
                        identifier: selectedLot.identifier,
                        area: selectedLot.area,
                        areaPrice: selectedLot.areaPrice,
                        finalPrice: parseInt(selectedLot.finalPrice),
                        kind: selectedLot.kind,
                        fundingEntry: parseInt(fundingEntry.toFixed(0)),
                        fundingEntryPercent:
                          selectedLot.appdata?.installments[i]
                            .minimuEntryPercentage * 100,
                        outstandingBalance: parseInt(
                          outstandingBalance.toFixed(0),
                        ),
                        numberOfInstallments: i,
                        rate: selectedLot.appdata?.installments[i].rate,
                        indexingRate:
                          selectedLot.appdata?.installments[i].indexingRate,
                        fundingInstallmentValue: parseInt(
                          fundingInstallmentValue.toFixed(0),
                        ),
                        fundingIntermediariesData: [],
                      };

                      return {
                        text: `${selectedLot.appdata?.installments[i].minimuEntryPercentage * 100}% + ${i}x R$ ${(fundingInstallmentValue / 100).toFixed(2).replace(".", ",")}${selectedLot.appdata?.installments[i].indexingRate ? ` + Idx` : ""}`,
                        onPress: () => {
                          setProposal({
                            project: data?.protocol.project,
                            selectedLot,
                            simulation,
                          });
                        },
                      };
                    }),
                    {
                      text: "Outro valor",
                      onPress: () => {
                        setProposal({
                          project: data?.protocol.project,
                          selectedLot,
                        });
                      },
                    },
                    {
                      text: "Fechar",
                      onPress: () => {
                        setModalIsOpen(false);
                      },
                    },
                  ]);

                  setModalIsOpen(true);
                }}
              />
            )}
          </div>
        </>
      )}

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => {
          setModalIsOpen(false);
        }}
        style={{
          content:
            mode === "desktop"
              ? {
                  top: "50%",
                  left: "50%",
                  right: "auto",
                  bottom: "auto",
                  marginRight: "-50%",
                  minWidth: 500,
                  transform: "translate(-50%, -50%)",
                  zIndex: 100,
                }
              : {
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 100,
                  overflow: "scroll",
                },
          overlay: {
            zIndex: 100,
          },
        }}
        contentLabel="Simular"
      >
        {selectedLot.preReservationEnabled ? (
          <>
            <h4>Solicitar Pré-reserva</h4>

            <Grid.Row className="mt-4">
              <Grid.Col>
                <h5 className="mt-5">Informações do Lote</h5>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Identificador</span>
                  <span>{selectedLot.identifier}</span>
                </div>

                {/* <div className="d-flex flex-column justify-content-between py-1">
                    <span style={{fontWeight: 600}}>Área Real (m²)</span>
                    <NumberFormat
                      value={selectedLot.area/100}
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      displayType="text"
                      fixedDecimalScale={true}
                      renderText={value => <span>{value}</span>}/>
                  </div>

                  <div className="d-flex flex-column justify-content-between py-1">
                    <span style={{fontWeight: 600}}>Preço Final do Lote (R$/m²)</span>
                    <NumberFormat
                      value={selectedLot.areaPrice/100}
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      displayType="text"
                      fixedDecimalScale={true}
                      renderText={value => <span>{value}</span>}/>
                  </div> */}

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Valor Final do Lote</span>
                  <NumberFormat
                    value={selectedLot.finalPrice / 100}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    displayType="text"
                    fixedDecimalScale={true}
                    prefix="R$ "
                    renderText={(value) => <span>{value}</span>}
                  />
                </div>
              </Grid.Col>
              <Grid.Col>
                <h5 className="mt-5">Dados do Cliente</h5>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Protocolo</span>
                  <span>{data?.protocol?.code}&nbsp;</span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Nome do Cliente</span>
                  <span>{data?.protocol?.clientName}&nbsp;</span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Email do Cliente</span>
                  <span>{data?.protocol?.clientEmail}&nbsp;</span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Celular do Cliente</span>
                  <span>{data?.protocol?.clientMobilePhone}&nbsp;</span>
                </div>
              </Grid.Col>
            </Grid.Row>
            <Button
              className="mt-4"
              block
              color="primary"
              disabled={loading}
              onClick={async () => {
                setLoading(true);

                try {
                  const res = await fetch(
                    `/api/broker/maps/pre-reservation?h=${hash}`,
                    {
                      method: "post",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        identifier: selectedLot.identifier,
                      }),
                    },
                  );

                  if (res.status === 200) {
                    alert.success("Lote pré-reservado com sucesso!");

                    setData(null);
                    const res = await fetch(`/api/broker/maps?h=${hash}`);
                    const json = await res.json();
                    json.linkedProjects = json?.linkedProjects?.reduce(
                      (acc, project) => ({ ...acc, [project.id]: project }),
                      {},
                    );

                    setData(json);

                    setModalIsOpen(false);
                  } else {
                    alert.error(`${(await res.json()).message}`);
                    setLoading(false);
                  }
                } catch (err) {
                  alert.error(`${err}`);
                }

                setLoading(false);
              }}
            >
              {loading ? "Enviando..." : "Fazer Pré-reserva"}
            </Button>
          </>
        ) : !proposal.simulation ? (
          <>
            <h4>Escolha uma opção de simulação</h4>
            <Button.List>
              {simulationOptions.map((option) => (
                <Button
                  block
                  outline
                  color="primary"
                  onClick={(e) => option.onPress(e)}
                >
                  {option.text}
                </Button>
              ))}
            </Button.List>
          </>
        ) : (
          <>
            <h4>Solicitar Reserva</h4>
            <Grid.Row className="mt-4">
              <Grid.Col>
                <h5>Dados do Corretor</h5>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Nome</span>
                  <span>{data?.protocol?.broker?.name}</span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Email</span>
                  <span>{data?.protocol?.broker?.email}</span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Celular</span>
                  <span>{data?.protocol?.broker?.mobilePhone}</span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>CRECI</span>
                  <span>{data?.protocol?.broker?.creci}</span>
                </div>
                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Imobiliária</span>
                  <span>{data?.protocol?.broker?.realState}</span>
                </div>
                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>CNPJ Imobiliária</span>
                  <span>{data?.protocol?.broker?.realStateDocument}&nbsp;</span>
                </div>
                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>CRECI Imobiliária</span>
                  <span>{data?.protocol?.broker?.realStateCreci}&nbsp;</span>
                </div>
                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>
                    Responsável Imobiliária
                  </span>
                  <span>
                    {data?.protocol?.broker?.realStateResponsibleName}&nbsp;
                  </span>
                </div>
                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Celular Responsável</span>
                  <span>
                    {data?.protocol?.broker?.realStateResponsibleMobilePhone}
                    &nbsp;
                  </span>
                </div>
                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Email Responsável</span>
                  <span>
                    {data?.protocol?.broker?.realStateResponsibleEmail}&nbsp;
                  </span>
                </div>
              </Grid.Col>

              <Grid.Col>
                <h5>Simulação</h5>
                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>
                    Entrada (
                    {proposal?.simulation?.fundingEntryPercent
                      .toFixed(2)
                      .replace(".", ",")}
                    %)
                  </span>
                  <NumberFormat
                    value={proposal?.simulation?.fundingEntry / 100}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    displayType="text"
                    fixedDecimalScale={true}
                    prefix="R$ "
                    renderText={(value) => <span>{value}</span>}
                  />
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Saldo devedor</span>
                  <NumberFormat
                    value={proposal?.simulation?.outstandingBalance / 100}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    displayType="text"
                    fixedDecimalScale={true}
                    prefix="R$ "
                    renderText={(value) => <span>{value}</span>}
                  />
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>
                    Juros{" "}
                    {proposal?.simulation?.indexingRate
                      ? `(+${proposal?.simulation?.indexingRate})`
                      : ""}
                  </span>
                  <span>
                    {(proposal?.simulation?.rate * 100)
                      .toString()
                      .replace(".", ",")}
                    %
                  </span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Número de parcelas</span>
                  <span>{proposal?.simulation?.numberOfInstallments}</span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Valor da parcela</span>
                  <NumberFormat
                    value={proposal?.simulation?.fundingInstallmentValue / 100}
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    displayType="text"
                    fixedDecimalScale={true}
                    prefix="R$ "
                    renderText={(value) => (
                      <span style={{ fontWeight: 600 }}>{value}</span>
                    )}
                  />
                </div>

                <h5 className="mt-5">Dados do Cliente</h5>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Protocolo</span>
                  <span>{data?.protocol?.code}&nbsp;</span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Nome do Cliente</span>
                  <span>{data?.protocol?.clientName}&nbsp;</span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Email do Cliente</span>
                  <span>{data?.protocol?.clientEmail}&nbsp;</span>
                </div>

                <div className="d-flex flex-column justify-content-between py-1">
                  <span style={{ fontWeight: 600 }}>Celular do Cliente</span>
                  <span>{data?.protocol?.clientMobilePhone}&nbsp;</span>
                </div>
              </Grid.Col>
            </Grid.Row>
            <Button
              className="mt-4"
              block
              color="primary"
              disabled={true}
              onClick={() => {}}
            >
              Em Breve...
            </Button>
          </>
        )}
      </Modal>
    </div>
  ) : (
    <div
      className="page"
      style={{
        backgroundImage: "url('./assets/images/landing_background.jpg')",
        backgroundSize: "cover",
      }}
    />
  );
}

export default ProtocolMapPage;
